export const BASE_URL = 'dashboard';
